const paths = {
  searchUrlDomestic: 'https://search.travel.rakuten.co.jp/ds/vacant/searchVacant',
  searchUrlOverseas: 'https://osearch.travel.rakuten.co.jp/os/search_result.do',
};

export default paths;
